<template>
  <v-container class="container--fluid text-center">
     <div style="height:350"  v-if="!this.ishavedata">
        <v-progress-circular
      :size="50"
      color="primary"
      indeterminate
    ></v-progress-circular></div>
      <div v-if="this.ishavedata" id="chart">
          <apexchart
            v-if="chartshow == 1"
            type="area"
            height="350"
            ref="chart"
            :options="chartOptions"
            :series="series"
          ></apexchart>
        </div>
  </v-container>
</template>

<script>

import VueApexCharts from "vue-apexcharts";
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";



Vue.use(VueAxios, axios);
export default {
  components: {
    apexchart: VueApexCharts,
  },
   props: {
        title: {
            type: String,
            default: null,
        },
         divvalue: {
            type: String,
            default: '',
        },
        
         divvaluelist: []
    },
  data: () => ({
    //for chart
    itemsplot: [],
    series: [],
    chartshow: 0,
    chartOptions: {
      chart: {
        id: "area-datetime",
        stacked: true,
        height: 350,
        zoom: {
          autoScaleYaxis: true,
        },
      },
      title: {
        text: "",
        align: "left",
      },
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 0,
        style: "hollow",
      },

      tooltip: {
        x: {
          format: "dd MMM yyyy",
        },
      },
      legend: {
        show: true,
      },
      stroke: {
        width: [0, 0, 0],
        curve: "smooth",
      },
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.9,
          stops: [0, 100],
        },
      },
      grid: {
        show: false, // you can either change hear to disable all grids
        xaxis: {
          lines: {
            show: false, //or just here to disable only x axis grids
          },
        },
        yaxis: {
          lines: {
            show: false, //or just here to disable only y axis
          },
        },
      },
    },

    xaxismin: null,
    xaxismax: null,
    //loading
    ishavedata:false,
     divdata: null,
    //end for chart
  }),

  methods: {
    getplot() {
        this.ishavedata=false;
       this.itemsplot = [];
             this.itemsplot =this.divdata;
            // alert(JSON.stringify( this.itemsplot ));
            this.getchartseries();
              this.ishavedata=true;
    },

    getchartseries() {
      var keys = [];
      var tkey = [];
      var datelist = [];
      for (var k1 in this.itemsplot[0]) {
        if (k1 != "date" && k1 != 'region') {
          keys.push(k1);
          var obj = new Object();
          obj.name = k1;
          var keysdata = [];
          for (var i = 0; i < this.itemsplot.length; i++) {
            datelist.push(new Date(this.itemsplot[i].date).getTime());
            var innerdata = [];
            //innerdata.push(k1);
            // let newval=new Date(this.itemsplot[i].t_date).getTime() + "," + this.itemsplot[i][k1];

            innerdata.push(new Date(this.itemsplot[i].date).getTime());
            innerdata.push(this.itemsplot[i][k1]);
            keysdata.push(innerdata);
          }

          obj.data = keysdata;

          tkey.push(obj);
        }
      }
      //this.newseries = tkey;
      this.series = [];
      this.series = tkey;

      let datelistarray = [];
      datelistarray = datelist;
      let maxdate = Math.max.apply(Math, datelistarray);
      let mindate = Math.min.apply(Math, datelistarray);
      this.xaxismin = mindate;
      this.xaxismax = maxdate;
      //alert(mindate);

      this.chartOptions = {
        ...this.chartOptions,
        ...{
          xaxis: {
            type: "datetime",
            min: mindate,
            max: maxdate,
            tickAmount: 6,
          },
          annotations: {
            yaxis: [
              {
                y: 0,
                borderColor: "#999",
                label: {
                  show: true,
                  text: "",
                  style: {
                    color: "#fff",
                    background: "#00E396",
                  },
                },
              },
            ],
            xaxis: [
              {
                x: mindate,
                borderColor: "#999",
                yAxisIndex: 0,

                label: {
                  show: true,
                  formatter: function (val) {
                    return "YY-" + val;
                  },
                  text: "",
                  style: {
                    color: "#fff",
                    background: "#775DD0",
                  },
                },
              },
            ],
          },
        },
      };
      this.chartshow = 1;
    },
    Refresh(vardata) {
      //alert(JSON.stringify(vardata));
      this.divdata=vardata;
      this.getplot();
    },
  },
  mounted() {
   
  },
};
</script>

<style scoped>
.title_text {
  font-size: 15px !important;
}

.v-label {
  font-size: 10px !important;
}

.selectedbtn {
  background-color: #0177b2 !important;
  color: white !important;
}

.nonselectedbtn {
  background-color: lightgrey !important;
  color: black !important;
  /* opacity: 40%;*/
}

.errorlog {
  background-color: rgba(255, 0, 0, 0.274);
  color: black;
}

.nonerrorlog {
  background-color: rgba(0, 128, 0, 0.377);
  color: black;
}
</style>
